import { render, staticRenderFns } from "./EditRoleModal.vue?vue&type=template&id=197a90c3&scoped=true&"
import script from "./EditRoleModal.vue?vue&type=script&lang=js&"
export * from "./EditRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./EditRoleModal.vue?vue&type=style&index=0&id=197a90c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a90c3",
  null
  
)

export default component.exports